export const FILE_UPLOAD_MAX_RETRIES = 3;
export const FILE_UPLOAD_RETRY_DELAY_MS = 1000;
